import React, { useEffect, useState, useRef, useCallback } from 'react';
import { Row, Button, Form, Col, Input, Radio, Spin, message } from 'antd';
import { SearchOutlined } from '@ant-design/icons';

import api from '../../../../services/api';
import { formatarCnpj, normalizarCnpj } from '../../../../helpers/utils';
import customerPlus from '../../../../assets/icons/customerPlus.svg';
import arrowRigth16 from '../../../../assets/icons/arrowRigth16.svg';
import { TitleSections } from '../../../../components/TitleSections';
import * as S from '../styles.js';

export function CustomerForm() {
  const [editCustomer, setEditCustomer] = useState([{}]);
  const [ListCustomer, setListCustomer] = useState([]);
  const [fromEdit, setFromEdit] = useState(false);
  const [loadingReprocessamento, setLoadingReprocessamento] = useState(false);
  const [buttonCancel, setButtonCancel] = useState(false);
  const [disableForm, setDisableForm] = useState(true);
  const [inputBusca, setInputBusca] = useState('');
  const [dateItem, setDateItem] = useState('');
  const [isActive, setIsActive] = useState();

  const [foneMask, setFoneMask] = useState('');
  const inputRef = useRef(null);
  const [form] = Form.useForm();

  const styleLocal = {
    input: {
      background: '#F2F2F2',
      border: 'none',
      height: '48px',
    },
    rowTop: {
      width: '100%',
      marginTop: '28px',
      display: 'flex',
    },
    colWithe: {
      background: '#fff',
      marginRight: '10px',
      borderRadius: '2px',
      width: '100%',
      paddingRight: '5px',
    },
    internCol: {
      borderRadius: '2px',
      height: '680px',
      overflow: 'auto',
      background: '#fff',
      padding: '130px 22px 16px',
    },
    internCol2: {
      borderRadius: '2px',
      height: '680px',
      overflow: 'auto',
      background: '#fff',
      padding: '42px 28px 0 28px',
    },
    formItem: {
      fontWeight: 'bold',
      fontSize: '14px',
      lineHeight: '16px',
      color: '#707070',
      margin: '20px 0',
    },
    checkStyle: {
      fontWeight: 'bold',
      fontSize: '14px',
      lineHeight: '16px',
      color: '#707070',
      margin: '0px 0 15px 0',
    },
    formItemButton: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      position: 'relative',
    },
  };

  const initialData = async () => {
    setLoadingReprocessamento(true);
    const registerNumber = '1000';
    const pageNumber = '1';
    const response = await api.get(
      `/cliente/list?page=${pageNumber}&numeroRegistros=${registerNumber}`
    );
    setListCustomer(response.data.items);
    setLoadingReprocessamento(false);
  };

  const listFiltered = ListCustomer?.filter(item => {
    if (item.ativo === true) {
      item.ativo = 'ativo';
    } else if (item.ativo === false) {
      item.ativo = 'inativo';
    }
    if (item.cnpj) {
      const cnpjFormatado = formatarCnpj(item.cnpj);
      const concatenado = item.nomeFantasia
        .concat(item.cnpj)
        .concat(item.ativo)
        .concat(cnpjFormatado);
      return concatenado.toLowerCase().includes(inputBusca.toLowerCase());
    }
      return null;
  });

  function ArrowRigth() {
  return <img src={arrowRigth16} alt="arrow" />;
}

  const [activeId, setActiveId] = useState(0);

  function RowsForUsers({ item }) {
    return (
      <S.RowsForColumn active={activeId === item.id}>
        <S.RowData
          key={item.id}
          justify="center"
          onClick={() => handleeditCustomer(item.id)}
        >
          <S.StyledColRow span={8}>{item.nomeFantasia}</S.StyledColRow>
          <S.StyledColRow span={8}>{formatarCnpj(item.cnpj)}</S.StyledColRow>
          <S.StyledColRow span={7}>{item.ativo}</S.StyledColRow>
          <S.StyledColRow span={1}>
            <ArrowRigth />
          </S.StyledColRow>
        </S.RowData>
      </S.RowsForColumn>
    );
  }

  function RowUsers({ users = [] }) {
    return (
      <>
        {users?.map((item, i) => <RowsForUsers key={i} item={item} />)}
      </>
    );
  }

  const handleeditCustomer = id => ListCustomer?.filter(item => {
      if (item?.id === id) {
        setActiveId(id);
        setIsActive(item?.ativo === 'ativo' ? 1 : 2);
        setDateItem(item?.dataCadastro);
        setEditCustomer(item);
        setFromEdit(true);
        setDisableForm(false);
        setButtonCancel(true);
        return;
      }
      return null;
    });

  const handleNewCustomer = async () => {
    setDisableForm(false);
    setEditCustomer([{}]);
    setFromEdit(false);
    setFoneMask();
    setIsActive(1);
    setButtonCancel(true);
    inputRef.current.focus({ cursor: 'start' });
  };

  const handleButtonCancel = () => {
    setFoneMask();
    setButtonCancel(false);
    setDisableForm(true);
    setIsActive();
    setEditCustomer([{}]);
  };

  const handleSubmitEdit = useCallback(
    async (event, item, fromEdit) => {
      if (event.cnpjForm.includes('_')) {
        message.error('CNPJ inválido');
        return inputRef?.current?.focus({ cursor: 'start' });
      }
      const { cnpjForm, razaoForm, nomeFantasiaForm, emailForm } = event;
      if (fromEdit) {
        let payload = [];

        const razaoSocial = razaoForm;
        const nomeFantasia = nomeFantasiaForm;
        const email = emailForm;
        const telefone = +foneMask
          .replace('(', '')
          .replace(')', '')
          .replace('-', '')
          .slice(2);
        const ddd = +foneMask
          .replace('(', '')
          .replace(')', '')
          .slice(0, 2);
        const ativo = isActive === 1;
        const dataCadastro = dateItem;
        const idContato = editCustomer?.contatos[0]?.id;
        const cnpj = normalizarCnpj(cnpjForm);
        if (cnpj.includes('_')) {
          message.error('CNPJ inválido.');
          return;
        }
        const nome = nomeFantasia;
        const id = item?.id;
        const contatos = [
          { email, ddd, telefone, nome, ativo, dataCadastro, id: idContato },
        ];
        payload = {
          cnpj,
          razaoSocial,
          nomeFantasia,
          contatos,
          ativo,
          id,
          dataCadastro,
        };

        try {
          await api.put('/cliente', payload);
          initialData();
          setEditCustomer([{}]);
          setListCustomer([{}]);
          setButtonCancel(false);
          setLoadingReprocessamento(false);
          setIsActive();
          setFoneMask();
          setDisableForm(true);
          return message.success(
            `Cliente ${payload?.nomeFantasia} atualizado com sucesso!`
          );
        } catch (err) {
          message.error(
            err?.response?.data?.detail || 'Erro ao atualizar cliente.'
          );
          setLoadingReprocessamento(false);
        }
      } else {
        try {
          let payload = [];
          const razaoSocial = razaoForm;
          const nomeFantasia = nomeFantasiaForm;
          const email = emailForm;
          const telefone = +foneMask
            .replace('(', '')
            .replace(')', '')
            .replace('-', '')
            .slice(2);
          const ddd = +foneMask
            .replace('(', '')
            .replace(')', '')
            .slice(0, 2);
          const ativo = isActive === 1;
          const dataCadastro = new Date();
          const cnpj = normalizarCnpj(cnpjForm);
          const nome = nomeFantasia;
          const contatos = [
            { email, ddd, telefone, nome, ativo, dataCadastro },
          ];
          payload = {
            cnpj,
            razaoSocial,
            nomeFantasia,
            contatos,
            ativo,
            dataCadastro,
          };
          await api.post('/cliente', payload);
          initialData();
          setEditCustomer([{}]);
          setListCustomer([{}]);
          setIsActive();
          setButtonCancel(false);
          setLoadingReprocessamento(false);
          setFoneMask();
          setDisableForm(true);
          message.success('Novo cliente cadastrado com sucesso!');
        } catch (err) {
          message.error(
            err?.response?.data?.detail || 'Erro ao cadastrar cliente.'
          );
          setLoadingReprocessamento(false);
        }
      }
    },
    [dateItem, editCustomer, isActive, foneMask]
  );

  useEffect(() => {
    initialData();
  }, []);

  useEffect(() => {
    const foneChecked =
      editCustomer?.contatos?.map(item => item?.telefone) || '';
    const dddChecked = editCustomer?.contatos?.map(item => item?.ddd) || '';
    const foneMoreDDD = `${`(${dddChecked})`}${foneChecked}`;
    form.setFieldsValue({
      cnpjForm: editCustomer?.cnpj ? formatarCnpj(editCustomer?.cnpj) : '',
      razaoForm: editCustomer?.razaoSocial || '',
      nomeFantasiaForm: editCustomer?.nomeFantasia || '',
      emailForm:
        editCustomer?.length === 1 ? '' : editCustomer?.contatos[0]?.email,
      telefoneForm:
        foneMoreDDD?.length < 11 ? foneMask : setFoneMask(foneMoreDDD),
      inativaForm: editCustomer?.ativo || '',
      grupoForm: editCustomer?.grupo || '',
    });
  }, [editCustomer]); // eslint-disable-line

  const checkFone = e => {
    setFoneMask(
      e?.target.value
        .replace(/\D/g, '')
        .replace(/(\d{2})(\d)/, '($1)$2')
        .replace(/(\d{4})(\d)/, '$1-$2')
        .replace(/(\d{4})-(\d)(\d{4})/, '$1$2-$3')
        .replace(/(-\d{4})\d+?$/, '$1')
    );
  };

  return (
    <Spin
      spinning={loadingReprocessamento}
      size="large"
      style={{
        width: '100%',
      }}
      tip="Carregando dados de Clientes"
      delay={200}
    >
      <>
        <Row span={24}>
          <S.StyledCol span={24} data-testid="topBarCliente">
            <h2>Clientes</h2>
            <Button
              data-testid="btnCliente"
              style={{
                paddingLeft: '8px',
                height: '45px',
                fontWeight: 'bold',
                width: '150px',
                fontSize: '16px',
              }}
              onClick={() => handleNewCustomer()}
            >
              <img src={customerPlus} alt="newUser" />
              Novo Cliente
            </Button>
          </S.StyledCol>
        </Row>
        <Row justify="center" id="row" style={styleLocal.rowTop}>
          <Col
            span={disableForm ? 24 : 12}
            align="center"
            style={{
              paddingRight: disableForm ? 0 : 24,
            }}
          >
            <Col style={styleLocal.colWithe}>
              <Row
                id="fixe"
                style={{
                  position: 'absolute',
                  width: '99%',
                  background: '#fff',
                  zIndex: '1',
                  padding: '24px 24px 0 24px',
                }}
                span={24}
              >
                <Input
                  placeholder="Busca"
                  onChange={e => setInputBusca(e.target.value)}
                  span={12}
                  style={styleLocal.input}
                  prefix={<SearchOutlined style={{ color: '#24A95D' }} />}
                />
                <Row
                  span={24}
                  style={{
                    position: 'relative',
                    width: '100%',
                    background: '#fff',
                    zIndex: '1',
                    marginTop: '5px',
                  }}
                >
                  <S.RowTitle
                    style={{
                      width: '100%',
                      background: '#fff',
                      borderBottom: '2px solid #CACACA',
                      marginBottom: '3px',
                      color: '#001F2A',
                      fontSize: '12px',
                    }}
                  >
                    <S.StyledColTitle span={8}>Nome</S.StyledColTitle>
                    <S.StyledColTitle span={8}>CNPJ</S.StyledColTitle>
                    <S.StyledColTitle span={7}>Status</S.StyledColTitle>
                    <S.StyledColTitle span={1} />
                  </S.RowTitle>
                </Row>
              </Row>
              <Col
                justify="center"
                id="col"
                span={24}
                style={styleLocal.internCol}
              >
                <RowUsers users={listFiltered} />
              </Col>
            </Col>
          </Col>
          <Col span={disableForm ? 0 : 12}>
            <Col style={styleLocal.colWithe}>
              <Col
                justify="center"
                id="col"
                span={24}
                style={styleLocal.internCol2}
              >
                <Row style={{ marginBottom: 22 }}>
                  <TitleSections title="Dados cadastrais do cliente" />
                </Row>
                <Form
                  form={form}
                  onFinish={values =>
                    handleSubmitEdit(values, editCustomer, fromEdit)
                  }
                  layout="vertical"
                  style={{ width: '100%', maxWidth: '100%', minWidth: '0' }}
                >
                  <Form.Item
                    name="nomeFantasiaForm"
                    label="Nome"
                    rules={[
                      { required: true, message: 'o nome deve ser informado' },
                    ]}
                    style={styleLocal.formItem}
                  >
                    <S.InputStyled
                      size="large"
                      disabled={disableForm}
                      placeholder="Nome"
                    />
                  </Form.Item>
                  <Form.Item
                    name="cnpjForm"
                    label="CNPJ"
                    rules={[
                      { required: true, message: 'o CNPJ deve ser informado' },
                    ]}
                    style={styleLocal.formItem}
                  >
                    <S.InputStyled
                      size="large"
                      disabled={disableForm}
                      placeholder="CNPJ"
                    />
                  </Form.Item>
                  <Form.Item
                    name="razaoForm"
                    label="Razão Social"
                    rules={[
                      {
                        required: true,
                        message: 'a razão social deve ser informada',
                      },
                    ]}
                    style={styleLocal.formItem}
                  >
                    <S.InputStyled
                      size="large"
                      disabled={disableForm}
                      placeholder="Razão Social"
                    />
                  </Form.Item>
                  <Form.Item
                    name="emailForm"
                    label="E-mail"
                    rules={[
                      {
                        required: true,
                        message: 'o e-mail deve ser informado',
                      },
                    ]}
                    style={styleLocal.formItem}
                  >
                    <S.InputStyled
                      size="large"
                      disabled={disableForm}
                      type="email"
                      placeholder="E-mail"
                    />
                  </Form.Item>
                  <Form.Item
                    label="Telefone"
                    rules={[
                      {
                        required: true,
                        message: 'o telefone deve ser informado',
                      },
                    ]}
                    style={styleLocal.formItem}
                  >
                    <S.InputStyled
                      size="large"
                      maxLength="14"
                      value={foneMask}
                      onChange={checkFone}
                      disabled={disableForm}
                      placeholder="Telefone"
                    />
                  </Form.Item>

                  <div
                    style={{
                      display: 'flex',
                      justifyContent: 'center',
                      alignItems: 'center',
                      flexDirection: 'column',
                      marginTop: '10%',
                    }}
                  >
                    <Radio.Group
                      style={styleLocal.checkStyle}
                      onChange={e => setIsActive(e.target.value)}
                      value={isActive}
                      disabled={disableForm}
                    >
                      <Radio value={1}>Ativo</Radio>
                      <Radio value={2}>Inativo</Radio>
                    </Radio.Group>
                    <Form.Item style={styleLocal.formItemButton}>
                      {buttonCancel && (
                        <S.StyledButtonCancel
                          type="primary"
                          htmlType="button"
                          onClick={() => handleButtonCancel()}
                        >
                          Cancelar
                        </S.StyledButtonCancel>
                      )}
                      <S.StyledButton
                        type="primary"
                        htmlType="submit"
                        disabled={disableForm}
                      >
                        Salvar
                      </S.StyledButton>
                    </Form.Item>
                  </div>
                </Form>
              </Col>
            </Col>
          </Col>
        </Row>
      </>
    </Spin>
  );
}
